export default __webpack_public_path__ + "static/media/referral-checkout.82647e6b.svg";